import { IonIcon } from "@ionic/react";
import Input from "@greeter-venue/components/Input";
import { InputProps } from "@greeter-venue/components/Input/Input";
import { classNames } from "@greeter/util";

import css from "./IconInput.module.scss";

export type IconInputProps = InputProps & {
  icon?: string;
};

export function IconInput({ icon, className, ...props }: IconInputProps) {
  return (
    <Input
      {...props}
      {...classNames(css.Input, className)}
      afterSlot={
        <div className={css.IconInput}>
          {icon && <IonIcon className={css.Icon} icon={icon} />}
        </div>
      }
    />
  );
}
